import { Flex } from '@chakra-ui/react'

export default function DoubleCircleIcon (props) {
  const {checkIcon, checkIconBg, checkIconFontSize, checkIconSize, icon, ...restProps} = props
  return (
    <Flex {...restProps} justify={'center'} align={'center'}>
      <Flex
        w={20}
        h={20}
        p={2}
        border={'1px'}
        borderColor='rgba(219,217,218,0.6)'
        position={'relative'}
        borderRadius={'full'}>
        <Flex
          justify={'center'}
          align={'center'}
          bg={'#ffffff'}
          w='100%'
          borderRadius={'full'}
          boxShadow={'0 0 4px 0 rgba(0,0,0,0.1)'}>
          <Flex
            position={'relative'}
            justify='center'
            align='center'
            height={'6'}
            width={'6'}
            right='2px'
            top='-2px'
            fontSize={'22px'}
            className={icon}>
            <Flex
              top={'11px'}
              right={'-5px'}
              justify={'center'}
              align={'center'}
              position={'absolute'}
              height={checkIconSize || '17px'}
              width={checkIconSize || '17px'}
              fontSize={checkIconFontSize || '9px'}
              bg={checkIconBg || 'primary'}
              border={'2px'}
              borderColor='white'
              borderRadius={'full'}
              color={'white'}
              className={checkIcon || 'zen-icon_ic_s-confirmed'}
            />
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  )
}
